import React from "react";

import PublicReport from "./PublicReport.js";

export default class MultiPrintPublic extends React.Component {

    componentDidMount(){
		if([...document.body.classList].indexOf("inReport") === -1)
		{
			document.body.classList.toggle("inReport");
        }
    }
    
	componentDidUpdate(){
		if([...document.body.classList].indexOf("inReport") === -1)
		{
			document.body.classList.toggle("inReport");
        }
    }
    
    render(){
        const data = JSON.parse(this.props.routeParams.datas).map(d => d.split(","));
        console.log("Props", data);
        return <React.Fragment>
            {
                data.map(d => <PublicReport {...this.props} params={{
                    ...this.props.params,
                    id: d[0],
                    hash: d[1],
                }} />)
            }
        </React.Fragment>;
    }
};


// WEBPACK FOOTER //
// ./src/components/MultiPrintPublic.js